import { render, staticRenderFns } from "./CompanyChildrenOverview.vue?vue&type=template&id=ce1dc656"
import script from "./CompanyChildrenOverview.vue?vue&type=script&lang=js"
export * from "./CompanyChildrenOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports